import { RiskTrendData } from '@/repositories/risk.repository';

export default function sortRiskTrendByDateDescending(data: RiskTrendData[]) {
  return data.slice().sort((a, b) => {
    const oldestDate = a.calculatedAt ? new Date(a.calculatedAt).getTime() : 0;
    const mostRecentDate = b.calculatedAt ? new Date(b.calculatedAt).getTime() : 0;
    return mostRecentDate - oldestDate;
  });
}
